/* DL v7 — swatch click-to-swap.
   Same logic as cgrid.js: clicking a colour-family swatch swaps the card in
   place (image, title, price, link, ATC variant id + availability) with no
   PDP navigation. Delegated on document so it covers every section instance
   and survives Theme-Editor section reloads. Loads once (guarded). */
(function () {
  if (window.__dlv7SwatchInit) return;
  window.__dlv7SwatchInit = true;

  document.addEventListener('click', function (e) {
    var sw = e.target.closest ? e.target.closest('[data-dlsw-swatch]') : null;
    if (!sw) return;
    e.preventDefault();

    var d = sw.dataset;
    var card = sw.closest('[data-dl-card]') || sw.closest('.dl-v7-product');
    if (card) {
      var img = card.querySelector('[data-dl-img]');
      var price = card.querySelector('[data-dl-price]');
      var name = card.querySelector('[data-dl-name]');
      var link = card.querySelector('[data-dl-link]');
      if (img && d.img) { img.removeAttribute('srcset'); img.src = d.img; }
      if (price && d.price) price.textContent = d.price;
      if (name && d.name) name.textContent = d.name;
      if (link && d.url) link.setAttribute('href', d.url);
    }

    var wrap = sw.closest('.dl-v7-wrap');
    if (wrap) {
      var vid = wrap.querySelector('[data-dl-vid]');
      if (vid && d.vid) vid.value = d.vid;
      var atcBtn = wrap.querySelector('[data-dl-atc-btn]');
      if (atcBtn && typeof d.available !== 'undefined') {
        var avail = d.available === 'true';
        atcBtn.disabled = !avail;
        atcBtn.classList.toggle('is-soldout', !avail);
      }
    }

    var row = sw.closest('.dlsw');
    if (row) {
      row.querySelectorAll('[data-dlsw-swatch]').forEach(function (x) { x.classList.remove('is-active'); });
    }
    sw.classList.add('is-active');
  });

  // Letter dropdown (A–Z products): choosing a letter sets the ATC variant id and enables the button.
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-dlsw-letter]')) return;
    var opt = sel.options[sel.selectedIndex];
    var card = sel.closest('[data-dl-card]') || sel.closest('.dl-v7-product');
    if (card && opt && opt.getAttribute('data-img')) {
      var img = card.querySelector('[data-dl-img]');
      if (img) { img.removeAttribute('srcset'); img.src = opt.getAttribute('data-img'); }
    }
    var wrap = sel.closest('.dl-v7-wrap');
    if (wrap) {
      var vid = wrap.querySelector('[data-dl-vid]');
      if (vid) vid.value = sel.value || '';
      var atcBtn = wrap.querySelector('[data-dl-atc-btn]');
      if (atcBtn) { atcBtn.disabled = !sel.value; atcBtn.classList.toggle('is-soldout', false); }
    }
  });

  // Gate Add-to-Cart for letter (A–Z) products until a letter is chosen.
  function dlv7InitLetterGates(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dlsw-letter]').forEach(function (sel) {
      var wrap = sel.closest('.dl-v7-wrap');
      if (!wrap) return;
      sel.selectedIndex = 0;
      var vid = wrap.querySelector('[data-dl-vid]');
      if (vid) vid.value = '';
      var atcBtn = wrap.querySelector('[data-dl-atc-btn]');
      if (atcBtn) atcBtn.disabled = true;
    });
  }
  if (document.readyState !== 'loading') dlv7InitLetterGates();
  else document.addEventListener('DOMContentLoaded', function () { dlv7InitLetterGates(); });
  document.addEventListener('shopify:section:load', function (e) { dlv7InitLetterGates(e.target); });
})();
